var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.outerContainerStyles)},[(_vm.center)?_c('div',{style:(_vm.centeringStyles)},[_vm._t("default",function(){return [_c('CSpinner',{attrs:{"grow":"","size":"lg","color":"primary"}})]})],2):_vm._t("default",function(){return [_c('CSpinner',{attrs:{"size":"lg","color":"primary"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }